import React from "react";
import "./Statistics.css";

export default function StatisticsSection() {
  return (
    <section className="stats-wrapper container">
      <div className="stats-box mx-auto">
        {/* Top Left Shape */}
        <div className="shape-top-left"></div>

        <div className="row text-center border-bottom pb-3">
          <div className="col-6 col-md-3 mb-4">
            <h2 className="stat-number">15K+</h2>
            <p className="stat-text">
              Scholarships Awarded Through Nova EduBridge Last Year
            </p>
          </div>
          <div className="col-6 col-md-3 mb-4">
            <h2 className="stat-number">11300+</h2>
            <p className="stat-text">
              Students Went to Study Abroad with Nova EduBridge
            </p>
          </div>
          <div className="col-6 col-md-3 mb-4">
            <h2 className="stat-number">800+</h2>
            <p className="stat-text">
              Nova EduBridge's Prestigious University Partners
            </p>
          </div>
          <div className="col-6 col-md-3 mb-4">
            <h2 className="stat-number">FREE</h2>
            <p className="stat-text">
              Counselling for Students & Parents
            </p>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-12 d-flex justify-content-center menu-links">
            <span className="active-link">Courses</span>
            <span>|</span>
            <span>Scholarships</span>
            <span>|</span>
            <span>Universities</span>
            <span>|</span>
            <span>Events</span>
            <span>|</span>
            <span>Guide me</span>
            <span>|</span>
            <span>New Updates</span>
          </div>
        </div>

        {/* Bottom Right Shape */}
        <div className="shape-bottom-right"></div>
      </div>
    </section>
  );
}
